import { NetworkRequestException } from '../../../exceptions/networkRequestException';
import { defaultErrorToTerm } from '../../../otherBusinessLogic/defaultErrorToTerm';

export function errorToTerm(exception: unknown): string {
  if (exception instanceof NetworkRequestException) {
    switch (exception.status) {
      case 429:
        return 'scaling_already_occurring';
    }
  }

  return defaultErrorToTerm(exception) ?? 'scaling_unknown_error';
}
